import { Text } from '@trmediaab/zebra';
import { useRef } from 'react';
import { Tooltip } from 'react-tooltip';

import { EMPTY_VALUE_CHARACTER } from '~/utils/numbers';

let uniqueId = 0;
const getUniqueId = () => uniqueId++;
const useUniqueId = prefix => {
  const idRef = useRef(getUniqueId());
  return `${prefix}_${idRef.current}`;
};

const CarriageTooltip = ({ id, content }) =>
  content ? (
    <Tooltip id={id}>
      <Text fontWeight="normal">{content}</Text>
    </Tooltip>
  ) : null;

export function Carriage({
  data,
  variant = 'plain',
  tooltipEnabled = false,
  ...textProps
}) {
  const tooltipId = useUniqueId('tooltip-carriage');
  const tooltipContent =
    data.value == null
      ? ['Vagninfo saknas']
      : [
          data.isFirstTime ? 'För första gången.' : null,
          data.isChanged ? `Senast: ${data.previousValue}` : null,
        ]
          .filter(Boolean)
          .join(' ');

  return (
    <Text
      fontWeight={variant !== 'plain' ? 'bold' : undefined}
      color={
        data.isChanged ? '#EB123A' : variant !== 'plain' ? 'black' : undefined
      }
      userSelect="none"
      {...(tooltipEnabled && { 'data-tooltip-id': tooltipId })}
      textDecoration={data.isChanged ? 'underline dotted #EB123A' : undefined}
      {...textProps}
    >
      {data.carriageShort ?? EMPTY_VALUE_CHARACTER}
      {tooltipEnabled && (
        <CarriageTooltip id={tooltipId} content={tooltipContent} />
      )}
    </Text>
  );
}
